import PropTypes from 'prop-types';
import './ScanRadioButton.scss';

const ScanRadioButton = ({ 
  text, 
  isSelected, 
  onClick, 
  className = '', 
  value, 
  name,
  disabled = false 
}) => {
  const handleClick = (event) => {
    if (!disabled) {
      onClick(event);
    }
  };

  return (
    <label
      className={`scan-radio-button ${isSelected ? 'selected' : 'unselected'} ${disabled ? 'disabled' : ''} ${className}`}
    >
      <input
        type="radio"
        name={name}
        value={value || text}
        checked={isSelected}
        onChange={handleClick}
        disabled={disabled}
        className="scan-radio-button-input"
      />
      <div className="scan-radio-button-group">
        <div className="scan-radio-button-outer-circle">
          <div className="scan-radio-button-inner-dot" />
        </div>
        <div className="scan-radio-button-label">{text}</div>
      </div>
    </label>
  );
};

ScanRadioButton.propTypes = {
  text: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool
};

ScanRadioButton.defaultProps = {
  className: '',
  disabled: false
};

export default ScanRadioButton;
